import type { ErrorCode } from '@atlassian/ui-modifications-core/types';
import messages from './messages';

export const errorCodeToErrorMessageMap: Record<ErrorCode, ReactIntl.FormattedMessage.MessageDescriptor> = {
    ON_BRIDGE_ERROR_ERROR_CODE: messages.applyingUimFailed,
    USE_REGISTER_FIELDS_ERROR_CODE: messages.applyingUimFailed,
    USE_SUBMIT_ERROR_CODE: messages.applyingUimFailed,
    PER_FIELD_HOOK_ERROR_CODE: messages.applyingUimFailed,
    SCOPES_MISSING_ERROR_CODE: messages.appDoesNotHaveRequiredScopes,
    ERROR_BOUNDARY_HANDLER_ERROR_CODE: messages.applyingUimFailed,
    ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: messages.loadingUimFailed,
};
